import enabled from 'data/enabled.json';

// กล่องสมัครสอบบน Dashboard โชว์ตั้งแต่เปิดรับสมัคร (start) เป็นต้นไป — หลังปิดรับยังค้างไว้ให้กดเข้าดูรายละเอียดการสมัคร
// (แบบเดียวกับ TCAS68/69 — สลับเป็น SectionTgatTpatSummary/SectionALevelSummary ด้วยมือตอนประกาศที่นั่งสอบ)
// timestamp มาจาก API = ms (clock.now — staging ใช้เวลาจำลอง ?now= ได้) รับ ISO string ด้วย · ค่าเพี้ยน/ไม่มี = ไม่โชว์
// start = เที่ยงคืนไทยวันเปิด ตรงกับ BE timewindows (tgattpat.pbt_apply / alevel.apply)
export const isApplyExamCardVisible = (windowKey, timestamp) => {
  const window = enabled[windowKey];
  const at = typeof timestamp === 'number' ? timestamp : Date.parse(timestamp);
  if (!window || !Number.isFinite(at)) return false;
  return at >= Date.parse(window.start);
};
